import { ACTION_STATES, ComplexAction, DefaultAction, createHandler, createReducer } from "core/actions";
import UserService from "services/userService";

export const initialState = {
    loadCredentialsStatus: ACTION_STATES.NO_REQUEST,
    authStatus: ACTION_STATES.NO_REQUEST,
    infoStatus: ACTION_STATES.NO_REQUEST,
    stateStatus: ACTION_STATES.NO_REQUEST,
    user: null,
    authenticated: false,
    authType: UserService.AUTH_TYPE_SSO,
    logoutStatus: ACTION_STATES.NO_REQUEST,
};

class AUTH_USER extends ComplexAction {
    constructor() {
        const props = {
            error: false,
            loadingAtr: "authStatus",
        };
        super(props);
    }
    successRdx(state, { payload }) {
        return Object.assign({}, state, {
            authStatus: ACTION_STATES.SUCCESS,
            ...payload,
        });
    }
    failedRdx(state) {
        return Object.assign({}, state, {
            authStatus: ACTION_STATES.FAILED,
            authenticated: false,
        });
    }
}

class AUTH_USER_VERIFY_SSO extends ComplexAction {
    constructor() {
        const props = {
            error: false,
            loadingAtr: "authStatusSSO",
        };
        super(props);
    }
    successRdx(state, { payload }) {
        return Object.assign({}, state, {
            authStatus: ACTION_STATES.SUCCESS,
            ...payload,
        });
    }
    failedRdx(state) {
        return Object.assign({}, state, {
            authStatus: ACTION_STATES.FAILED,
            authenticated: false,
        });
    }
}

class INFO_USER extends ComplexAction {
    constructor() {
        const props = {
            error: false,
            loadingAtr: "infoStatus",
        };
        super(props);
    }
    successRdx(state, { payload }) {
        return {
            ...state,
            user: payload,
        };
    }
    failedRdx(state) {
        return Object.assign({}, state, { authStatus: ACTION_STATES.FAILED });
    }
}

class LOAD_USER extends DefaultAction {
    callRdx(state, { payload }) {
        return Object.assign({}, state, {
            user: payload,
        });
    }
}

export class ON_LOGOUT extends ComplexAction {
    successRdx(state) {
        return Object.assign({}, state, {
            logoutStatus: ACTION_STATES.SUCCESS,
            authenticated: false,
        });
    }
    failedRdx(state) {
        return Object.assign({}, state, { logoutStatus: ACTION_STATES.FAILED });
    }
}
export class ON_LOAD_CREDENTIALS extends ComplexAction {
    successRdx(state, { payload }) {
        return Object.assign({}, state, {
            loadCredentialsStatus: ACTION_STATES.SUCCESS,
            logoutStatus: ACTION_STATES.NO_REQUEST,
            ...payload,
        });
    }
}

export const actions = {
    AUTH_USER: new AUTH_USER(),
    AUTH_USER_VERIFY_SSO: new AUTH_USER_VERIFY_SSO(),
    INFO_USER: new INFO_USER(),
    LOAD_USER: new LOAD_USER(),
    ON_LOAD_CREDENTIALS: new ON_LOAD_CREDENTIALS("loadCredentialsStatus"),

    LOGOUT: new ON_LOGOUT(),
};
const handlers = createHandler(actions);

export default createReducer(initialState, handlers);

export const selectorCurrentUserEmail = ({ login }) => (login.user ? login.user.email : null);
export const isAuthenticatedSelector = ({ login }) => login.authenticated;
export const currentUserPrivilegesSelector = ({ login }) => (login.user ? login.user.privileges : {});
export const currentUserBlockedPathsSelector = ({ login }) =>
    login.user && login.user.privileges ? login.user.privileges.blockedPaths : {};
export const currentUserSelector = ({ login }) => login.user;
export const currentUserIdSelector = ({ login }) => (login.user ? login.user.id : null);
export const currentUsername = ({ login }) => (login.user ? login.user.username : null);
export const currentFirstNameSelector = ({ login }) => (login.user ? login.user.firstName : null);
export const currentFullNameSelector = ({ login }) => (login.user ? `${login.user.firstName} ${login.user.lastName}`: null);

